<template>
  <div style="position: relative; background: #fff; overflow: hidden; padding-bottom: 10px">
    <div class="lock" v-show="!editEnable || !workFlowStatus">
      <el-divider>
        <div v-if="thondarYON">
          <span v-if="baseId == 101" class="my-text">{{ "请在变更的受影响物件页签中编辑该对象" }}</span>
          <i v-else class="el-icon-lock lock-icon"></i>
        </div>
        <div v-else>
          <i class="el-icon-lock lock-icon"></i>
        </div>

      </el-divider>
    </div>
    <div style="position: fixed;  z-index: 999;  right: 120px;  margin-top: 15px;">
      <el-button type="success" size="mini" @click="submitForm" :disabled="noEdit" v-if="edit"
        icon="el-icon-circle-check">{{ $t("message.button.save") }}</el-button>
      <el-button type="primary" size="mini" @click="editInfo" :disabled="!editEnable || !workFlowStatus"
        :icon="EditCancel.icon">{{ EditCancel.name }}</el-button>

    </div>
    <!-- <div v-show="!edit" class="pageInfoShow">
      <el-collapse v-model="activeName">
        <el-collapse-item :title="item.name" :name="index" v-for="(item, index) in pageInfo" :key="index">
          <PageShow :page="item" :pageIndex="index" :key="timeRefusr" :reset="resetNum">
          </PageShow>
        </el-collapse-item>
      </el-collapse>
    </div> -->
    <div v-if="!edit">
      <div v-for="(item, index) in pageInfo" :key="index">
        <PageShow :page="item" :pageIndex="index" :key="timeRefusr" :reset="resetNum">
        </PageShow>
      </div>
    </div>
    <!--
    <div v-if="edit && isItem && itemNotModifyable">
      <div v-for="(item, index) in pageInfo" :key="index">
        <PageShow :page="item" :pageIndex="index" :key="timeRefusr" :reset="resetNum">
        </PageShow>
      </div>
    </div>
	 -->
    <!-- <div v-if="edit"> -->
    <div v-else>
      <div v-if="isItem && itemNotModifyable">
        <div v-for="(item, index) in pageInfo" :key="index">
          <PageShow :page="item" :pageIndex="index" :key="timeRefusr" :reset="resetNum">
          </PageShow>
        </div>
      </div>
      <el-form size="mini" ref="form" label-width="280px">
        <div v-for="(item, index) in pageInfo" :key="index">
          <PageEdit :page="item" ref="pageEdit" :pageIndex="index" :editNum="editNum" :change.sync="item.value"
            @hasChanged="editChange" @MFValue="getMF" :key="timeRefusr" :checkReq.sync="item.req">
          </PageEdit>
        </div>
      </el-form>
    </div>


  </div>
</template>

<script>
import axios from "axios";
import PageShow from "./page/pageShow.vue";
import { baseInfo } from "@/utils/publicstate";
import PageEdit from './page/pageEdit.vue'
export default {
  name: 'pageInfo',
  data() {
    return {
      activeName: [0, 1, 2],
      remindModifyCodeAttributes: false,
      codeAttributes: [],
      isItem: false,//是否是Item对象
      itemNotModifyable: false,

      // EditCancel: this.$t("message.button.edit"),
      resetNum: 0,
      timeRefusr: new Date().getTime(),

      pageInfo: [],
      edit: false,
      isClearable: true,
      editNum: 0,
      editEnable: false,
      noEdit: true,
      manufacturerId: "",
      pageOrder: [this.$t("message.title.pageOne"), this.$t("message.title.pageTwo"), this.$t("message.title.pageThree")],

      getUrl: {},
      reqList: {},

      input_width: {
        width: "76%",
      },
      mId: false,

      objectId: { ...this.$store.state.objectId },
      changeId: {},

      workFlowStatus: true,//变更工作流状态

      componentname: this.$route.matched[1].path.slice(1),
      thondarYON: false,  //用于判断当前租户是否为Thondar
      baseId: '',

    };
  },
  components: {
    PageShow,
    // PageEdit: () => import("./page/pageEdit.vue"),
    PageEdit
  },
  mounted() { },
  methods: {
    closeInfo() {
      this.edit = false;
      this.noEdit = true;
      this.reset();
    },
    editChange() {
      this.noEdit = false;
      // this.$store.commit('setIncludesList','item');
      this.$store.commit('setPageChanged', { name: this.componentname, isChanged: true });
    },

    reset() {
      this.resetNum++;
    },

    getMF(e) {
      this.manufacturerId = e;
      this.mId = true;
    },
    // submitForm(e) {
    //   // console.log(this.manufacturerId);},

    getInsertData(arr) {
      const [pageOne, pageTwo, pageThree] = arr.map(i => {
        const { columnInfo, pageData } = i;
        const idList = columnInfo.map(j => j.id);
        const obj = {};
        pageData.map((j, e) => {
          const val = Array.isArray(j) ? j.join(';') : j;
          const key = idList[e];
          obj[key] = val

        })
        return obj
      })
      return {
        pageOne, pageTwo, pageThree,
        objectId: this.objectId,
        changeId: this.changeId,
      }
    },

    submitForm() {
      // // console.log(this.manufacturerId);

      const req = this.pageInfo.map(i => i.req);
      const arr = this.$refs.pageEdit;
      const insertDataObj = this.getInsertData(arr);

      if (req.some(i => !i && i != undefined)) {
        this.$message.error(this.$t('message.warning.required'))
        return;
      }

      const valList = this.pageInfo.map((i) => i.value);
      const [pageOne = {}, pageTwo = {}, pageThree = {}] = valList;

      const modifyCodeAttributes = Object.keys({ ...pageOne, ...pageTwo }).some(i => this.codeAttributes.includes(i));



      this.objectId.version = this.$store.state.change_info.changeId;
      if (this.mid) {
        Object.assign(pageOne, { manufacturerId: this.manufacturerId });
      }

      // // console.log(this.remindModifyCodeAttributes);
      // let modifyCodeAttributes = false;
      // for (let i = 0; i < valList.length; i++) {
      //   if (i == 1 || i == 2) {
      //     // console.log(i);
      //     if (valList[i]) {
      //       let attributes = Object.keys(valList[i]);
      //       // console.log(attributes);
      //       for (let j = 0; j < attributes.length; j++) {
      //         let flag1 = this.codeAttributes.findIndex(item => item === attributes[j])
      //         // console.log(flag1);
      //         if (this.codeAttributes.indexOf(Number(attributes[j])) != -1) {
      //           modifyCodeAttributes = true;
      //         }
      //       }
      //     }
      //   }
      // }

      const obj = {
        pageOne, pageTwo, pageThree,
        objectId: this.objectId,
        changeId: this.changeId,
      }

      if (this.type !== "item") {
        this.setSave(obj)
        return
      } else {
        this.setSaveItem(insertDataObj, obj, modifyCodeAttributes);
      }

    },
    modifConfirm() {
      return this.$confirm(
        this.$t("message.confirm.modifyCodeAttributes"),
        this.$t("message.tips.tip"),
        {
          confirmButtonText: this.$t("message.button.affirm"),
          cancelButtonText: this.$t("message.button.cancel"),
          type: "warning",
        }
      )
    },
    setSaveItem(insertDataObj, obj, modifyCodeAttributes) {

      if (this.remindModifyCodeAttributes && modifyCodeAttributes) {
        this.modifConfirm()
          .then(() => {
            this.setInsertItem(insertDataObj, obj)
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("message.tips.saveCancel"),
            });
          });

      } else {
        this.setInsertItem(insertDataObj, obj)
      }

    },

    setInsertItem(insertDataObj, obj) {
      axios.post(`/pmdm/items/getInsertItemInfo`, insertDataObj).then(res => {
        const { ItemDescErrList } = res.data.object;
        if (!ItemDescErrList.length) {
          this.setSave(obj);
        } else {
          ItemDescErrList.unshift(this.$t('message.tips.duplicateObject'));
          const strs = ItemDescErrList.join('<br>')
          this.$confirm(strs, { type: 'warning', dangerouslyUseHTMLString: true, }).then(res => {
            this.setSave(obj)
          }).catch(_ => {
          })
        }
      })

    },
    setSave(obj) {
      axios
        .post(this.getUrl.saveTable, obj)
        .then((res) => {
          //// console.log(res);
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getTitleBlockInfo();
            this.$emit("routeClick");
            this.noEdit = true;
            this.editNum = 0;
            this.edit = !this.edit;
            this.$store.commit('setPageChanged', { name: this.componentname, isChanged: false });
            this.$emit("update");
          }
        });
    },
    editInfo() {

      this.edit = !this.edit;
      this.editNum++;
      console.log(this.edit);
      if (!this.edit) {
        this.$store.commit('setPageChanged', { name: this.componentname, isChanged: false });
      }
      this.itemNotModifyable = false;
      if (this.changeRevInfo != undefined && this.changeRevInfo.length > 1) {
        this.itemNotModifyable = true;
        this.editEnable = false;
      }
    },

    getPriv() {

      const arr = JSON.parse(sessionStorage.getItem("userContext")).privs;
      const pagePriv = arr.filter((i) => i.classId == this.objectId.subClassId).map((i) => i.type);

      const baseId = parseInt(this.objectId.classId.toString().substr(0, 3));

      const isSupAdmin = this.$store.state.isSuperAdmin;

      if (pagePriv.includes(3) || isSupAdmin) {
        this.editEnable = true;
      };
      if (baseId == 101 && this.changeRevInfo.length > 1) {
        this.itemNotModifyable = true;
        this.editEnable = false;
      } else if (baseId == 501 && this.changeRevInfo.length > 1) {
        this.itemNotModifyable = true;
        this.editEnable = false;
      };
    },

    async getData(e) {
      const { data } = await axios.get(this.getUrl.loadTable, { params: e })
      return data;
    },

    getTitleBlockInfo() {

      const change_info = this.$store.state.change_info;
      const baseId = parseInt(this.objectId.classId.toString().substr(0, 3));

      if (baseId == 101 || baseId == 501) {
        this.changeId = {
          id: change_info.changeId,
          classId: change_info.changeClassId,
          subClassId: change_info.changeSubClassId,
        }
      }
      this.getUrl = baseInfo.find(i => i.id == baseId);
      const pageList = new Array(3).fill("_").map((i, e) => {
        const obj = {
          ... this.objectId,
          ...change_info,
          tableId: e + 1
        };
        return this.getData(obj)
      });
      Promise.all(pageList).then(res => {
        console.log(res);
        this.pageInfo = res.map((i, e) => {
          const { columnInfo, rows } = i.object.table;
          return {
            column: columnInfo,
            val: rows[0],
            name: this.pageOrder[e]
          }
        })

        if (baseId === 101) {
          const [p1, p2, p3] = res;
          this.remindModifyCodeAttributes = baseId == 101 && (p2.object.needRemind || p3.object.needRemind)
          const xx = !p3.object.remindAttrList.length ? p2.object.remindAttrList : p3.object.remindAttrList;
          this.codeAttributes = [...xx]
        }

        const strMapList = new Map([
          [101, "isItem"],
          [104, "isChange"],
          [105, "isManufacturer"],
          [106, "isManufacturerPart"],
          [401, "isQuality"],
          [501, "isTechnology"],
          [502, "isResource"],
          [901, "isUser"],
          [902, "isUserGroup"],
        ]);
        const str = strMapList.get(baseId);
        this.$store.commit("setItemTitleBlockImg", str);
      })
    },
    changeType(res) {
      this.$forceUpdate();
    },
  },
  created() {
    // console.log(this.changeValue);
    // console.log(this.changeRevInfo);
    this.getTitleBlockInfo();
    this.getPriv();
    // this.$store.commit("setIncludesList", 'pageInfo');
    let tenantName = window.sessionStorage.systemName;
    if (tenantName.indexOf("Thondar") == -1) {
      this.thondarYON = false;
    } else {
      this.thondarYON = true;
    }
    // const {id,classId,subClassId} = this.objectId;
    this.baseId = parseInt(this.objectId.classId.toString().substr(0, 3));
  },
  computed: {
    loadWorkFlowStatus() {
      return this.$store.state.changeWorkflowStatus;
    },
    EditCancel() {
      if (!this.edit) {
        return { name: this.$t("message.button.edit"), icon: 'el-icon-edit' }
      } else {
        return { name: this.$t("message.button.cancel"), icon: 'el-icon-circle-close' }
      }
    }
  },
  props: ['changeValue', 'type', 'changeRevInfo'],

  watch: {
    loadWorkFlowStatus: {
      handler(val) {
        const baseId = this.$store.state.objectId.classId.toString().substr(0, 3);
        if (baseId == 401) {
          this.workFlowStatus = !([3, 4].includes(val))
        } else if (baseId == 104) {
          this.workFlowStatus = !([3, 4].includes(val))
        } else {
          this.workFlowStatus = true
        }
        console.log({ baseId, val, w: this.workFlowStatus });
      },
      deep: true,
      immediate: true,
    },
    changeRevInfo: function (value) {
      if (this.changeRevInfo.length > 1) {
        this.itemNotModifyable = true;
        this.editEnable = false;
      }
    },
    changeValue: function (value) {
      this.getTitleBlockInfo();
    },

    type: function (e) {
      this.pageType = e;
    },
    '$route.query.refresh': {
      immediate: true,
      handler() {
        this.getTitleBlockInfo();
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    console.log(to, from);
    const tabs = [...this.$store.state.showingTabsInHome];
    const activeName = this.$store.state.activedTabInHome;
    if (!this.$store.state.pageChanged) {//就是上面的状态 如果是true , 则不询问是否保存, 当然这个方法比较笨, 大家可以使用更优雅的方式
      next();
    } else {

      this.$confirm("当前页面有未保存信息，确定离开么", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.commit('setPageChanged', { name: this.componentname, isChanged: false });
          next();
          if (to.path == from.matched[1].path) {
            this.$store.commit("setPageRefresh");
          }
        })
        .catch(() => {
          this.$store.commit("replaceShowingTabsInHome", tabs);
          this.$store.commit("setActivedTabInHome", activeName);
        });
    }
  },

};
</script>

<style>
ol,
ul {
  list-style: none;
}

.moneyUi .el-input-group__append {
  width: 30% !important;
}

.pageInfoShow .el-collapse-item__header {
  padding-left: 20px;
  font-size: 16px;
  font-weight: 600;
}

.pageInfoShow .el-collapse-item__content {
  padding-bottom: 0;
}
</style>

<style scoped>
.lock {
  padding-top: 15px;
  width: 90%;
  margin: auto;

}

.lock-icon {
  font-size: 26px;
  color: #99a9bf;
}

.my-text {
  font-size: 18px;
  color: #99a9bf;
}

.heading-edit {
  width: 100% !important;
  margin: 0 0 18px 40px;
}

.view-page2 {
  position: relative;
  overflow: hidden;
  list-style: none;
  width: 100%;
  margin-top: 20px;
  padding-left: 40px;
  padding-top: 20px;
  padding-bottom: 20px;
  background: #f4f7f9;
  background-image: url(~@/assets/titleBlock/page2.png);
  background-repeat: no-repeat;
  background-position: bottom right;
}

.view-page3 {
  position: relative;
  overflow: hidden;
  list-style: none;
  width: 100%;
  margin-top: 20px;
  padding-left: 40px;
  padding-bottom: 20px;
}

.heading {
  width: 100%;
  float: left;
  margin: 0px 0 18px 0;
}

.heading p {
  font-size: 18px;
  margin: 0;
}

.title-heading {
  width: 100%;
  float: left;
  margin: 0 0 18px -20px;
}

.title-heading p {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}

.page1 {
  width: 50%;
  overflow: hidden;
}

.page2 {
  width: 50%;
  float: left;
}

.page3 {
  width: 50%;
  float: left;
}

ul {
  margin: 0;
}

.line01 {
  border-bottom: 1px solid #cecece;
  padding: 10px 0;
}

div {
  font-size: 12px;
}

.table-list {
  height: 20px;
  overflow: hidden;
  margin-top: 4px;
}

.table-list li {
  overflow: hidden;
}

.table-list .list-key {
  display: inline-block;
  width: 42%;
  text-align: right;
  font-size: 14px;
}

.table-list .list-val {
  display: inline-block;
  width: 52%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 18px;
  font-size: 14px;
  position: relative;
  top: 3px;
}

.table-list .list-key-1 {
  display: inline-block;
  width: 18.5%;
  text-align: right;
  font-size: 14px;
  color: #000;
}
</style>
